import type { SVGProps } from "react";
import { cn } from "@/lib/cn";
import { SOCIAL_LABELS, socialLinks, type SocialNetwork } from "@/lib/siteLinks";

/* Simple outline glyphs (lucide has no brand icons). Monochrome, so they take the text colour. */
const PATHS: Record<SocialNetwork, string> = {
  tiktok: "M14 3v10.5a3.5 3.5 0 1 1-3.5-3.5M14 3c.4 2.6 2.2 4.5 5 4.8",
  instagram: "M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm5 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm5.5-1.5h.01",
  x: "M4 4l16 16M20 4L4 20",
  facebook: "M15 8h-2a2 2 0 0 0-2 2v11M8 13h7",
  linkedin: "M4 9v11M4 4.5v.01M9 20v-6a3 3 0 0 1 6 0v6M9 9v11M15 20v-6",
  youtube: "M3 8.5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-7ZM10 9.5l5 2.5-5 2.5v-5Z",
  telegram: "M21 4 3 11l6 2 2 6 3-4 5 4 2-15ZM9 13l9-6",
};

function Glyph({ network, ...props }: { network: SocialNetwork } & SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d={PATHS[network]} />
    </svg>
  );
}

/** Row of social profile links (only the networks configured in VITE_SOCIAL_*). */
export function SocialIcons({ className }: { className?: string }) {
  const links = socialLinks();
  if (!links.length) return null;
  return (
    <ul className={cn("flex flex-wrap gap-2", className)}>
      {links.map(({ network, url }) => (
        <li key={network}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`RealityStore on ${SOCIAL_LABELS[network]}`}
            className="grid size-11 place-items-center rounded-full border border-line bg-fg/[0.04] text-ink-soft transition hover:border-[var(--border-glow)] hover:text-ink"
          >
            <Glyph network={network} className="size-5" aria-hidden />
          </a>
        </li>
      ))}
    </ul>
  );
}
